import {closeAllKI_Image_Overlays, KIOverlaySelectors, showKI_Image_Overlay} from "./KIOverlaySelectors";

export class KIOverlayNavigationButtons {
    private static initialized: boolean;

    private static getCloseButtonSelector = (o:KIOverlaySelectors) => o + " .btn-close";
    private static getBackButtonSelector = (o:KIOverlaySelectors) => o + " .btn-back";

    private static getSelectorForAllCloseButtons() {
        const out:string[] = [];
        for(const o in KIOverlaySelectors) {
            out.push(KIOverlayNavigationButtons.getCloseButtonSelector(KIOverlaySelectors[o]))
        }
        return out.join(", ");
    }

    public static init() {
        const self=KIOverlayNavigationButtons;
        if(self.initialized) {
            return;
        }

        document.querySelectorAll(self.getSelectorForAllCloseButtons()).forEach(e=>e.addEventListener("click", closeAllKI_Image_Overlays));
        document.querySelector(self.getBackButtonSelector(KIOverlaySelectors.CHOOSE_STYLE)).addEventListener("click", closeAllKI_Image_Overlays);
        document.querySelector(self.getBackButtonSelector(KIOverlaySelectors.ENTER_PROMPT)).addEventListener("click", ()=>showKI_Image_Overlay(KIOverlaySelectors.CHOOSE_STYLE));
        document.querySelector(self.getBackButtonSelector(KIOverlaySelectors.RESULT)).addEventListener("click", ()=>showKI_Image_Overlay(KIOverlaySelectors.ENTER_PROMPT));
        document.querySelectorAll(".esc-prompt")
            .forEach(e=>e.addEventListener("click", closeAllKI_Image_Overlays));
        self.initialized = true;
    }
}
